<template>
  <div id="nft-sidebar" class="col-sm-3 col-xl-2" :class="{ active: isActive }">
    <div id="nft-btnbar-wrapper">
      <ButtonBar position="top">
        <slot name="top-bar" :showContent="showContent" :activeContent="activeContent"></slot>
      </ButtonBar>
      <ButtonBar position="bottom">
        <slot name="bottom-bar" :showContent="showContent" :activeContent="activeContent"></slot>
      </ButtonBar>
    </div>

    <div id="nft-sidebar-content" ref="contents">
      <slot name="contents"></slot>
    </div>
  </div>
</template>

<script>
  import ButtonBar from './ButtonBar'

  export default {
    name: 'Sidebar',
    components: {
      ButtonBar,
    },
    props: ['sidebarData'],
    data: function () {
      return {
        isActive: false,
        activeContent: null,
        contents: {},
      }
    },
    watch: {
      isActive: function (val) {
        if (val) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      },
      activeContent: function (val, oldVal) {
        if (oldVal != null) {
          this.contents[oldVal].classList.add('content-hidden')
        }
        if (val != null) {
          this.contents[val].classList.remove('content-hidden')
        }
      },
    },
    methods: {
      showContent: function (contentRef) {
        if (this.activeContent === contentRef && this.isActive === true) {
          this.isActive = false
          this.activeContent = null
        } else {
          this.activeContent = contentRef
          this.isActive = true
        }
      },
    },
    mounted () {
      const contents = this.$refs['contents'].children
      const referencedContents = {}
      for (let i = 0; i < contents.length; i++) {
        const content = contents[i]
        content.classList.add('content-hidden')
        const ref = content.dataset.contentRef
        referencedContents[ref] = content
      }
      this.contents = referencedContents
    },
  }
</script>

<style scoped lang="scss">
  #nft-sidebar {
    display: flex;
    flex-direction: column;
    background-color: white;
    margin-top: -$navbar-height;
    min-height: 100%;
    border-left: 1px solid $gray-300;
    margin-right: - percentage(3 / $grid-columns);
    padding: 0;
    // transition: margin-right 0.1s;
    @include media-breakpoint-up(xl) {
      margin-right: - percentage(2 / $grid-columns);
    }

    &.active {
      margin-right: 0;
      box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.2);
    }
  }

  #nft-sidebar-content {
    display: flex;
    flex-direction: column;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    padding: map-get($spacers, 4);
    height: 100vh;
  }

  #nft-btnbar-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    left: -($btnbar-width);
    padding-left: $btnbar-padding-x;
    padding-right: $btnbar-padding-x;
    height: 100%;
    z-index: $zindex-sticky;
    pointer-events: none;
  }

  .content-hidden {
    display: none !important;
  }
</style>

<style lang="scss">
  .sidebar-title {
    font-size: $sidebar-title-font-size;
  }
</style>